<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        class="grid-col-1-2 grid-row-1-2"
        :root="rootNode" 
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="input-block grid-col-2-3 grid-row-1-2">
        <label>
          Size
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.TEXT_SIZE"></tooltip>
        </label>
        <select name="size" required v-model="formData.size">
          <option v-for="(value, key) in this.SIZE" :key="key" :value="key">
            {{ value }}
          </option>
        </select>
      </div>
      <div class="input-block grid-col-1-3 grid-row-3-4">
        <label>
          Content
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.TEXT_CONTENT"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.content"
          name="content"
          required
          @blur="generateFieldName()"
        />
      </div>
      <div class="input-block grid-col-3-4 grid-row-3-4">
        <label>
          Field Name (auto-populated)
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.FIELD_NAME"></tooltip>
        </label>
        <input
          type="text"
          v-model="formData.fieldName"
          name="fieldName"
          required
          disabled
        />
      </div>
      <div class="grid-col-1-4 grid-row-4-5">
        <slot></slot>
      </div>
      <fieldset
        v-if="!simpleView"
        class="more-option grid-col-1-4 grid-row-5-6"
      >
        <legend>More Options</legend>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { TEXT_SIZE, ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { populateFieldName } from "../mixins/component-utils-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";
import { Bus } from "../main";

export default {
  name: "TextModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: ROOT_NODE.AREAS,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
      SIZE: TEXT_SIZE,
      populateFieldName: populateFieldName,
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("metadataSaved", this.formData);
        } else {
          this.formData = structuredClone(this.metadata);
        }
      }
    },
    simpleView: function () {
      this.insertIntoComponentModal();
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
  },
  mounted() {
    this.insertIntoComponentModal();

    Bus.$on("sendDupFieldName", (list) => this.checkDupFieldName(list));
  },
  beforeDestroy() {
    Bus.$off("sendDupFieldName");
  },
  methods: {
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
    getSelectedSize: function (size) {
      return size.toLowerCase() === this.formData.size.toLowerCase();
    },
    insertIntoComponentModal: function () {
      const gridRow = "2 / 3";
      Bus.$emit("insertIntoComponentModal", this.$refs.body, gridRow);
    },
    // 1) Populate field name
    // 2) Emit event to FormEditor to check duplicate
    // 3) FormEditor send the list of duplicate field name using Bus
    // 4) If the list is not empty, adjust the field name
    generateFieldName: function () {
      const fieldName = populateFieldName(this.formData, 'content');
      if (fieldName) {
        Bus.$emit("getDupFieldName", fieldName);
      }
    },
    // If there is duplicate field name, append field name with counter
    checkDupFieldName: function (list) {
      const fieldName = this.formData.fieldName;
      if (list.length > 0) {
        let count = 1;
        let temp = fieldName ;
        while (list.find(name => name == temp)) {
          temp = fieldName + (count++);
        }
        count--;
        this.formData.fieldName = temp;
      }
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 0 9px 3px 9px;
  margin-top: 3px;
  cursor: pointer;
  font-weight: bolder;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-1-3 {
  grid-column: 1 / 3;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-col-2-3 {
  grid-column: 2 / 3;
}

.grid-col-3-4 {
  grid-column: 3 / 4;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.grid-row-5-6 {
  grid-row: 5 / 6;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>